export default {
  navItems: [
    {
      name: "Products",
      desktopDropdown: [
        {
          header: "Payments",
          text:
            "Send a single check or a million, we have the solution for you.",
          icon: "/img/payments.png",
          link: "/product/payments/",
          sub_links: [
            {
              text: "ACH Payments",
              link: "/product/payments/ach/",
            },
            {
              text: "Real-Time Payments",
              link: "/product/payments/real-time-payments/",
            },
            {
              text: "Printable Checks",
              link: "/product/payments/printable-checks/",
            },
            {
              text: "Instant Pay",
              link: "/product/payments/instant-pay/",
            },
            {
              text: "Mailed Checks",
              link: "/product/payments/mailed-checks/",
            },
            {
              text: "Virtual Cards",
              link: "/product/payments/virtual-cards/",
            },
            {
              text: "FedNow Payments",
              link: "/product/payments/fednow-payments/",
            },
          ],
        },
        {
          header: "Invoices",
          text: "You can request a Digital Check too. Simply send an invoice.",
          icon: "/img/invoices.png",
          link: "/product/invoices/",
        },
      ],
      mobileDropdown: [
        {
          text: "ACH Payments",
          link: "/product/payments/ach/",
        },
        {
          text: "Mailed Checks",
          link: "/product/payments/mailed-checks/",
        },
        {
          text: "Printable Checks",
          link: "/product/payments/printable-checks/",
        },
        {
          text: "Real-Time Payments",
          link: "/product/payments/real-time-payments/",
        },
        {
          text: "Virtual Cards",
          link: "/product/payments/virtual-cards/",
        },
        {
          text: "Instant Pay",
          link: "/product/payments/instant-pay/",
        },
        {
          text: "FedNow Payments",
          link: "/product/payments/fednow-payments/",
        },
      ],
    },
    {
      name: "Solutions",
      desktopDropdown: [
        {
          header: "Multi-party",
          text: "Create an endorsable digital payment to two parties.",
          icon: "/img/multiparty.png",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          header: "PayFac Marketplace",
          text: "Facilitate payments between your vendors and customers.",
          icon: "/img/marketplace_nav.png",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          header: "Integrations",
          text: "Learn about Checkbook, our company, and how it all works.",
          icon: "/img/integrations_nav.png",
          link: "https://docs.checkbook.io/docs/",
          sub_links: [
            {
              text: "QuickBooks",
              link: "https://docs.checkbook.io/docs/integrations/quickbooks/",
            },
            {
              text: "Sage Intacct",
              link: "https://docs.checkbook.io/docs/integrations/sage-intacct/",
            },
            {
              text: "Accounting Seed",
              link: "https://docs.checkbook.io/docs/integrations/accounting-seed/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "Multi-party",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          text: "PayFac Marketplace",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          text: "Integrations",
          link: "https://docs.checkbook.io/docs/",
        },
      ],
    },
    {
      name: "Company",
      desktopDropdown: [
        {
          header: "Company",
          text: "Learn more about Checkbook and how it all works.",
          icon: "/img/company.png",
          link: "/company/about-us/",
          sub_links: [
            {
              text: "About Us",
              link: "/company/about-us/",
            },
            {
              text: "Compliance",
              link: "/company/compliance/",
            },
            {
              text: "How it Works",
              link: "/company/how-it-works/",
            },
            {
              text: "Security",
              link: "/company/security/",
            },
            {
              text: "Careers",
              link: "https://boards.greenhouse.io/checkbook",
            },
            {
              text: "Terms of Service",
              link: "/company/terms-individual/",
            },
          ],
        },
        {
          header: "Resources",
          text: "Need more information? We've got you covered.",
          icon: "/img/resources.png",
          sub_links: [
            {
              text: "Blog",
              link: "/blog/",
            },
            {
              text: "Case Studies",
              link: "/resource/case-studies/",
            },
            {
              text: "Privacy Policy",
              link: "/resource/privacy/",
            },
            {
              text: "Press",
              link: "/press/",
            },
            {
              text: "Logos",
              link: "/resource/logos/",
            },
            {
              text: "FAQ",
              link: "https://faq.checkbook.io/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "About Us",
          link: "/company/about-us/",
        },
        {
          text: "Compliance",
          link: "/company/compliance/",
        },
        {
          text: "How it Works",
          link: "/company/how-it-works/",
        },
        {
          text: "Security",
          link: "/company/security/",
        },
        {
          text: "Careers",
          link: "https://boards.greenhouse.io/checkbook",
        },
        {
          text: "Terms of Service",
          link: "/company/terms-individual/",
        },
        {
          text: "Blog",
          link: "/blog/",
        },
        {
          text: "Case Studies",
          link: "/resource/case-studies/",
        },
        {
          text: "Privacy Policy",
          link: "/resource/privacy/",
        },
        {
          text: "Press",
          link: "/press/",
        },
        {
          text: "Logos",
          link: "/resource/logos/",
        },
        {
          text: "FAQ",
          link: "https://faq.checkbook.io/",
        },
      ],
    },
    {
      name: "Pricing",
      link: "/pricing/",
    },
    {
      name: "Developer",
      link: "https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ",
    },
  ],
  enca_navItems: [
    {
      name: "Products",
      desktopDropdown: [
        {
          header: "Payments",
          text:
            "Send a single cheque or a million, we have the solution for you.",
          icon: "/img/payments.png",
          link: "/en-ca/product/payments/",
          sub_links: [
            {
              text: "ACH Payments",
              link: "/en-ca/product/payments/ach/",
            },
            {
              text: "Real-Time Payments",
              link: "/en-ca/product/payments/real-time-payments/",
            },
            {
              text: "Printable Cheques",
              link: "/en-ca/product/payments/printable-cheques/",
            },
            {
              text: "Instant Pay",
              link: "/en-ca/product/payments/instant-pay/",
            },
            {
              text: "Mailed Cheques",
              link: "/en-ca/product/payments/mailed-cheques/",
            },
            {
              text: "Virtual Cards",
              link: "/en-ca/product/payments/virtual-cards/",
            },
            {
              text: "FedNow Payments",
              link: "/en-ca/product/payments/fednow-payments/",
            },
          ],
        },
        {
          header: "Invoices",
          text: "You can request a Digital Cheque too. Simply send an invoice.",
          icon: "/img/invoices.png",
          link: "/en-ca/product/invoices/",
        },
      ],
      mobileDropdown: [
        {
          text: "ACH Payments",
          link: "/en-ca/product/payments/ach/",
        },
        {
          text: "Mailed Cheques",
          link: "/en-ca/product/payments/mailed-cheques/",
        },
        {
          text: "Printable Cheques",
          link: "/en-ca/product/payments/printable-cheques/",
        },
        {
          text: "Real-Time Payments",
          link: "/en-ca/product/payments/real-time-payments/",
        },
        {
          text: "Virtual Cards",
          link: "/en-ca/product/payments/virtual-cards/",
        },
        {
          text: "Instant Pay",
          link: "/en-ca/product/payments/instant-pay/",
        },
        {
          text: "FedNow Payments",
          link: "/en-ca/product/payments/fednow-payments/",
        },
      ],
    },
    {
      name: "Solutions",
      desktopDropdown: [
        {
          header: "Multi-party",
          text: "Create an endorsable digital payment to two parties.",
          icon: "/img/multiparty.png",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          header: "PayFac Marketplace",
          text: "Facilitate payments between your vendors and customers.",
          icon: "/img/marketplace_nav.png",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          header: "Integrations",
          text: "Learn about Checkbook, our company, and how it all works.",
          icon: "/img/integrations_nav.png",
          link: "https://docs.checkbook.io/docs/",
          sub_links: [
            {
              text: "QuickBooks",
              link: "https://docs.checkbook.io/docs/integrations/quickbooks/",
            },
            {
              text: "Sage Intacct",
              link: "https://docs.checkbook.io/docs/integrations/sage-intacct/",
            },
            {
              text: "Accountingseed",
              link: "https://docs.checkbook.io/docs/integrations/accounting-seed/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "Multi-party",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          text: "PayFac Marketplace",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          text: "Integrations",
          link: "https://docs.checkbook.io/docs/",
        },
      ],
    },
    {
      name: "Company",
      desktopDropdown: [
        {
          header: "Company",
          text: "Learn more about Checkbook and how it all works.",
          icon: "/img/company.png",
          link: "/en-ca/company/about-us/",
          sub_links: [
            {
              text: "About Us",
              link: "/en-ca/company/about-us/",
            },
            {
              text: "Compliance",
              link: "/en-ca/company/compliance/",
            },
            {
              text: "How it Works",
              link: "/en-ca/company/how-it-works/",
            },
            {
              text: "Security",
              link: "/en-ca/company/security/",
            },
            {
              text: "Careers",
              link: "https://boards.greenhouse.io/checkbook",
            },
            {
              text: "Terms of Service",
              link: "/company/terms-individual/",
            },
          ],
        },
        {
          header: "Resources",
          text: "Need more information? We've got you covered.",
          icon: "/img/resources.png",
          sub_links: [
            {
              text: "Blog",
              link: "/blog/",
            },
            {
              text: "Case Studies",
              link: "/resource/case-studies/",
            },
            {
              text: "Privacy Policy",
              link: "/resource/privacy/",
            },
            {
              text: "Press",
              link: "/press/",
            },
            {
              text: "Logos",
              link: "/en-ca/resource/logos/",
            },
            {
              text: "FAQ",
              link: "https://faq.checkbook.io/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "About Us",
          link: "/en-ca/company/about-us/",
        },
        {
          text: "Compliance",
          link: "/en-ca/company/compliance/",
        },
        {
          text: "How it Works",
          link: "/en-ca/company/how-it-works/",
        },
        {
          text: "Security",
          link: "/en-ca/company/security/",
        },
        {
          text: "Careers",
          link: "https://boards.greenhouse.io/checkbook",
        },
        {
          text: "Terms of Service",
          link: "/company/terms-individual/",
        },
        {
          text: "Blog",
          link: "/blog/",
        },
        {
          text: "Case Studies",
          link: "/resource/case-studies/",
        },
        {
          text: "Privacy Policy",
          link: "/resource/privacy/",
        },
        {
          text: "Press",
          link: "/press/",
        },
        {
          text: "Logos",
          link: "/en-ca/resource/logos/",
        },
        {
          text: "FAQ",
          link: "https://faq.checkbook.io/",
        },
      ],
    },
    {
      name: "Pricing",
      link: "/en-ca/pricing/",
    },
    {
      name: "Developer",
      link: "https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ",
    },
  ],
  frca_navItems: [
    {
      name: "Produits",
      desktopDropdown: [
        {
          header: "Paiements",
          text:
            "Envoyez un seul chèque ou un million, nous avons la solution pour vous.",
          icon: "/img/payments.png",
          link: "/fr-ca/product/payments/",
          sub_links: [
            {
              text: "Paiements ACH",
              link: "/fr-ca/product/payments/ach/",
            },
            {
              text: "Paiements en temps réel",
              link: "/fr-ca/product/payments/real-time-payments/",
            },
            {
              text: "Chèques imprimés",
              link: "/fr-ca/product/payments/printable-cheques/",
            },
            {
              text: "Paiements instantanés",
              link: "/fr-ca/product/payments/instant-pay/",
            },
            {
              text: "Envoi postal",
              link: "/fr-ca/product/payments/mailed-cheques/",
            },
            {
              text: "Cartes virtuelles",
              link: "/fr-ca/product/payments/virtual-cards/",
            },
            {
              text: "Paiements FedNow",
              link: "/fr-ca/product/payments/fednow-payments/",
            },
          ],
        },
        {
          header: "Factures",
          text:
            "Vous pouvez également demander un chèque numérique. Envoyez simplement une facture.",
          icon: "/img/invoices.png",
          link: "/fr-ca/product/invoices/",
        },
      ],
      mobileDropdown: [
        {
          text: "Paiements ACH",
          link: "/fr-ca/product/payments/ach/",
        },
        {
          text: "Envoi postal",
          link: "/fr-ca/product/payments/mailed-cheques/",
        },
        {
          text: "Chèques imprimés",
          link: "/fr-ca/product/payments/printable-cheques/",
        },
        {
          text: "Paiements en temps réel",
          link: "/fr-ca/product/payments/real-time-payments/",
        },
        {
          text: "Cartes virtuelles",
          link: "/fr-ca/product/payments/virtual-cards/",
        },
        {
          text: "Paiements instantanés",
          link: "/fr-ca/product/payments/instant-pay/",
        },
        {
          text: "Paiements FedNow",
          link: "/fr-ca/product/payments/fednow-payments/",
        },
      ],
    },
    {
      name: "Solutions",
      desktopDropdown: [
        {
          header: "Multipartite",
          text: "Créer un paiement numérique endossable à deux parties.",
          icon: "/img/multiparty.png",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          header: "Plateforme PayFac",
          text:
            "Facilitez les paiements entre vos fournisseurs et vos clients.",
          icon: "/img/marketplace_nav.png",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          header: "Intégrations",
          text:
            "Découvrez Checkbook, notre entreprise et comment tout cela fonctionne.",
          icon: "/img/integrations_nav.png",
          link: "https://docs.checkbook.io/docs/",
          sub_links: [
            {
              text: "QuickBooks",
              link: "https://docs.checkbook.io/docs/integrations/quickbooks/",
            },
            {
              text: "Sage Intacct",
              link: "https://docs.checkbook.io/docs/integrations/sage-intacct/",
            },
            {
              text: "Accountingseed",
              link: "https://docs.checkbook.io/docs/integrations/accounting-seed/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "Multipartite",
          link: "https://docs.checkbook.io/docs/products/payments/multiparty/",
        },
        {
          text: "Plateforme PayFac",
          link: "https://docs.checkbook.io/docs/products/marketplace/",
        },
        {
          text: "Intégrations",
          link: "https://docs.checkbook.io/docs/",
        },
      ],
    },
    {
      name: "Entreprise",
      desktopDropdown: [
        {
          header: "Entreprise",
          text: "En savoir plus sur le chéquier et son fonctionnement.",
          icon: "/img/company.png",
          link: "/fr-ca/company/about-us/",
          sub_links: [
            {
              text: "Qui sommes nous",
              link: "/fr-ca/company/about-us/",
            },
            {
              text: "Conformité",
              link: "/fr-ca/company/compliance/",
            },
            {
              text: "Comment ça marche",
              link: "/fr-ca/company/how-it-works/",
            },
            {
              text: "Sécurité",
              link: "/fr-ca/company/security/",
            },
            {
              text: "Nous rejoindre",
              link: "https://boards.greenhouse.io/checkbook",
            },
            {
              text: "Conditions d'utilisation",
              link: "/company/terms-individual/",
            },
          ],
        },
        {
          header: "Ressources",
          text: "Besoin de plus d'informations? Nous sommes là pour vous.",
          icon: "/img/resources.png",
          sub_links: [
            {
              text: "Blog",
              link: "/blog/",
            },
            {
              text: "Études de cas",
              link: "/resource/case-studies/",
            },
            {
              text: "Politique de confidentialité",
              link: "/resource/privacy/",
            },
            {
              text: "Presse",
              link: "/press/",
            },
            {
              text: "Logos",
              link: "/fr-ca/resource/logos/",
            },
            {
              text: "FAQ",
              link: "https://faq.checkbook.io/",
            },
          ],
        },
      ],
      mobileDropdown: [
        {
          text: "Qui sommes nous",
          link: "/fr-ca/company/about-us/",
        },
        {
          text: "Conformité",
          link: "/fr-ca/company/compliance/",
        },
        {
          text: "Comment ça marche",
          link: "/fr-ca/company/how-it-works/",
        },
        {
          text: "Sécurité",
          link: "/fr-ca/company/security/",
        },
        {
          text: "Nous rejoindre",
          link: "https://boards.greenhouse.io/checkbook",
        },
        {
          text: "Conditions d'utilisation",
          link: "/company/terms-individual/",
        },
        {
          text: "Blog",
          link: "/blog/",
        },
        {
          text: "Études de cas",
          link: "/resource/case-studies/",
        },
        {
          text: "Politique de confidentialité",
          link: "/resource/privacy/",
        },
        {
          text: "Presse",
          link: "/press/",
        },
        {
          text: "Logos",
          link: "/fr-ca/resource/logos/",
        },
        {
          text: "FAQ",
          link: "https://faq.checkbook.io/",
        },
      ],
    },
    {
      name: "Tarifs",
      link: "/fr-ca/pricing/",
    },
    {
      name: "Documentation",
      link: "https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ",
    },
  ],
};
